import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Shop } from 'src/app/dto';
import { AuthenticatedPageComponent } from 'src/app/components/base.component';
import { MainpageComponent } from 'src/app/components/mainpage/mainpage.component';
import { AuthService } from 'src/app/services/auth.service';
import { ShopService } from 'src/app/services/shop.service';
import { UIStateService } from 'src/app/services/ui-state.service';

@Component({
    selector: 'app-shop-finder',
    templateUrl: './shop-finder.component.html',
    styleUrls: ['./shop-finder.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopFinderComponent extends AuthenticatedPageComponent implements OnInit {

    public static route: String = 'shopfinder';

    protected shops = signal<Shop[]>(undefined);

    constructor(private shopSvc: ShopService, private route: ActivatedRoute, authService: AuthService, router: Router, uiStateService: UIStateService) {
        super(router, authService, MainpageComponent.route, uiStateService);
    }


    ngOnInit(): void {
        // switchMap cancels any still-pending getAllShops() call if route.params re-emits before
        // it resolves, and the whole pipeline is tracked via the View base class's subscribe()
        // helper for cleanup on destroy - the previous nested-subscribe shape left the inner
        // getAllShops() subscription both untracked and undisposed on a route.params re-fire.
        this.subscribe(
            this.route.params.pipe(switchMap(() => this.shopSvc.getAllShops())),
            shops => { this.shops.set(shops); });
    }
}
